export enum LogLevel {
  DEBUG = 0,
  INFO,
  WARN,
  ERROR,
  OFF,
}

export function fromString(str: string) {
  if (!isLogLevelString(str)) {
    throw new Error(`Illegal log level value '${str}'`)
  }

  return LogLevel[str.toUpperCase() as keyof typeof LogLevel] // safe after isLogLevelString()
}

function isLogLevelString(str: string): str is keyof typeof LogLevel {
  for (const v of Object.keys(LogLevel)) {
    if (v === str.toUpperCase()) {
      return true
    }
  }

  return false
}
